<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-09 23:32:47
 * @LastEditTime: 2025-09-13 17:09:23
-->
<template>
    <div class="listPost">

        <div style="padding: 10px;">
            <div style="display: flex;align-items: center;">
                <van-field v-model="keyword"  placeholder="请输入关键词" style="width:calc(100% - 134px);border: 1px solidd #ddd;"/>
                <van-button style="border-radius: 4px;margin-left: 8px;background-color: rgb(20,65,134);border: none;"
                @click="addText" type="info" >添加</van-button>
                <van-button style="border-radius: 4px;margin-left: 8px;background-color: rgb(20,65,134);border: none;"
                @click="handleSearch" type="info" >搜索</van-button>
            </div>
            <div style="color: red;font-size: 12px;width: 100%;margin-top: 8px;">
                输入关键词后请点击添加即可筛选
            </div>


            <div v-if="keywordList.length" style="margin-top: 10px;">
                <van-tag closeable size="medium" type="primary" style="margin-right: 10px;background-color: rgb(20,65,134)"
                    v-for="(item, index) in keywordList" :key="index" @close="close1(index)">{{
                    item
                }}</van-tag>
            </div>
        </div>
        



      <div class="ui-content" style="margin-top: 16px">
        <section class="record-list">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              :immediate-check="false"
              finished-text="没有更多了"
              @load="onLoad"
              offset="20"
              error-text="请求失败，点击重新加载"
            >
              <li v-for="item,index in tableData" :key="index" class="li-items">
                <div style="margin: 10px">
                  <div class="items-content">
                    <ol>
                      <li v-for="value,key,i in item" :key="i">
                        <span class="label">{{key}}：</span>
                        <span class="label-content multiline-ellipsis" :style="{'line-height': '16px', color: key.includes('链接') ? 'blue' : ''}" @click="showContent($event, value, key)">{{ value }}</span>
                      </li>
                    </ol>
                  </div>
                </div>
              </li>
  
              <!-- 加载状态提示 -->
              <template #loading>
                <div class="loading-text">加载中...</div>
              </template>
            </van-list>
          </van-pull-refresh>
        </section>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import { experienceDataList, experienceHeader } from '@/api/xicaiquan'
  import { Tag, List, PullRefresh, Button, Toast, Dialog } from 'vant'
  Vue.use(Tag)
  Vue.use(List)
  Vue.use(PullRefresh)
  Vue.use(Button)
  Vue.use(Dialog)
  export default {
    name: 'listPost',
    props: {
      type: String,
      form: Object
    },
    data () {
      return {
        list: [1, 2, 3], // 列表数据
        loading: false, // 列表加载状态
        finished: false, // 列表是否加载完成
        isLoading: false, // 下拉刷新状态
        page: 1, // 当前页码
        pageSize: 10, // 每页条数
        queryParams: {
          current: 1,
          size: 10
        },
        apiHeader: [],
        apiData: [],
        search: '',
        tableDataTotal: 0,
        keyword: '',
        keywordList: []
      }
    },
    created () {
        const id = this.$route.query.id;
        this.queryParams.id = id;

        this.loadData()

        this.getDataHeader()
    },
    computed: {
        // 转换后的表格数据
        tableData() {
            return this.apiData.map(row => {
                const obj = {};
                this.apiHeader.forEach((col, i) => {
                    obj[col] = row[i] !== undefined ? row[i] : ''; // 处理undefined值
                });
                return obj;
            });
        },
        // 直接使用转换后的表头
        tableHeader() {
            return this.apiHeader;
        },
    },
    components: {},
    watch: {},
    methods: {
      async getData () {
        this.loading = true;
        const res = await experienceDataList({...this.queryParams, search: this.search});
        if (res.code == 200) {
            this.tableDataTotal = res.data.total;
            if (this.queryParams.current === 1) {
              this.apiData = res.data.records

              console.log("apiData", this.tableData)
            } else {
              // 否则追加数据
              this.apiData = [...this.apiData, ...res.data.records]
            }
  
            // 判断是否还有更多数据
            if (res.data.records.length < this.queryParams.size) {
              this.finished = true
            }


        } else {
            this.apiData = [];
            this.tableDataTotal = 0;
        }
        this.loading = false;
      },
      async getDataHeader() {
        const res = await experienceHeader({id: this.queryParams.id});
        if (res.code == 200) {
            this.apiHeader = res.data;
        }
      },
      // 加载数据
      async loadData () {

          this.getData()
  
      },
  
      // 列表滚动到底部时触发
      onLoad () {
        if (this.finished) return
        this.queryParams.current++
        this.loadData()
      },
  
      // 下拉刷新触发
      onRefresh () {
        this.queryParams.current = 1
        this.finished = false
        this.loading = true
        this.loadData()
      },

      addText() {
        if (!this.keyword) return;
        this.keywordList.push(this.keyword);
        this.keyword = "";

      },
      handleSearch() {
        this.searchList()
      },
      close1(index) {
        this.keywordList.splice(index, 1)

        this.searchList()
      },
      searchList() {
        this.search = this.keywordList.join(' ')
        this.queryParams.current = 1
        this.finished = false;
        this.loadData()
      },
      isTextOverflowing(element) {
        const style = window.getComputedStyle(element);
        
        // 获取行高（处理'normal'情况）
        const lineHeight = style.lineHeight === 'normal' 
          ? parseFloat(style.fontSize) * 1.2 // 默认行高为字体的1.2倍
          : parseFloat(style.lineHeight);
        
        // 计算三行理论高度（含内边距和边框）
        const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        const border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        const expectedHeight = lineHeight * 3 + padding + border;
      
        // 比较实际内容高度
        return element.scrollHeight > expectedHeight;
      },
      showContent(e, value, key) {
        console.log()
        const flag = this.isTextOverflowing(e.target);

        if (flag) {
          Dialog.alert({
              title: '查看内容',
              messageAlign:'left',
              message: value,
          }).then(() => {
              // on close
          });
        }

        if (key.includes('链接')) {
          this.copyUrl(value)
        }
        console.log(e.target.innerText, value)
      },
      copyUrl (text) {
          // on confirm
          // 创建一个临时的文本输入框
          const tempInput = document.createElement('input')
          // 将需要复制的内容赋值给输入框
          tempInput.value = text
          // 将输入框添加到文档中
          document.body.appendChild(tempInput)
          // 选中输入框的内容
          tempInput.select()
          // 执行复制命令
          document.execCommand('copy')
          // 从文档中移除临时输入框
          document.body.removeChild(tempInput)

          Toast('复制成功')
      }
  
    }
  }
  </script>
  <style scoped lang="scss">
  .listPost {
    width: 100%;
    .ui-content {
      width: 95%;
      margin: 0px auto;
      .li-items {
        border-radius: 10px;
        background: #fff;
        margin-bottom: 20px;
        p {
          border-bottom: 1px solid #ddd;
          line-height: 40px;
          padding: 10px;
        }
  
        .title {
          background: #e0edfe;
          border-radius: 10px 10px 0px 0px;
          line-height: 40px;
          font-size: 16px;
          text-indent: 20px;
          margin-top: 20px;
          position: relative;
          overflow: hidden;
          padding-right: 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
  
          .ribbon {
            width: 80px;
            height: 40px;
            background: orange;
            position: absolute;
            top: 0;
            right: -25px;
            transform: rotate(34deg);
            transform-origin: top right;
            box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
          }
  
          .ribbon-text {
            position: absolute;
            top: 12px;
            right: 12px;
            color: white;
            font-weight: bold;
            font-size: 12px;
            transform: rotate(0deg);
            transform-origin: right center;
            font-family: 'Arial', sans-serif;
          }
  
          /* 可选：让角标右上角带圆角 */
          .ribbon::before {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 12px;
            height: 12px;
            background: white;
            border-top-left-radius: 12px;
          }
        }
  
        .items-content {
          background: #fafbff;
          padding: 2px;
          .tag {
            display: flex;
          }
  
          ol {
            margin: 20px 0px;
            li {
              display: flex;
              margin: 20px 0px;
              .label {
                color: #999;
                white-space: nowrap;
                width: 120px;
              }
              .label-content {
              }
            }
          }
        }
  
        .items-content-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #ddd;
          padding: 14px 10px;
          background: #fafbff;
        }
      }
    }
  }


.multiline-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 限制显示3行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* 可选：确保容器有固定宽度 */
  width: 100%;
  line-height: 1.5;
  max-height: 4.5em; /* 3行 * 1.5行高 */
}
  </style>
  